import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControlPipe } from "@bequeathed/ngx-utils";
import { BaseInputControl } from '../base-input-control/base-input-control.component';
import { ReactiveFormsModule } from "@angular/forms";
import { KeyValuePipe, NgClass } from "@angular/common";


/**
 * Basic textarea input field component with label, description element, validation message area and the input element styling (feedback icon, border change)
 *
 * @author Adam Jennings (ajennings)
 */
@Component({
    standalone: true,
    selector: 'text-control',
    templateUrl: './text-control.component.html',
    styleUrls: [
        './text-control.component.sass',
        '../base-input-control/base-input-control.component.sass',
        '../../base-form/base-form.component.sass'
    ],
    imports: [
        // Angular
        NgClass,
        ReactiveFormsModule,
        // Bequeathed
        FormControlPipe,
        KeyValuePipe
    ],
    encapsulation: ViewEncapsulation.None
})
export class TextControl extends BaseInputControl implements OnInit {

    constructor() {
        super();
    }

    override ngOnInit() {
        super.ngOnInit();

        if (this.editingResponse) {
            this.setPreviousResponse()
        }
    }

}
